import {
  mobileapp_main_coverimage,
} from "../../../assets/data/Imagedata";

import {
  DefaultIcon,
} from "../../../assets/data/icon_data";


export const MobileAppDesignDetails = {
  SeoName: {
    seotitle: "MobileAppDesignDetailsseo",
  },
  section2: {
    tagline: "Want a modern and engaging mobile app design?",
    heading: "Creative & User-Friendly Mobile App Design Solutions",
    description:
      "At Cyber Space Digital, we craft intuitive, visually appealing, and user-centered mobile app designs that enhance engagement and improve user experiences across iOS, Android, and cross-platform applications.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Mobile App UI/UX Design",
      description: "Intuitive and visually compelling interfaces.",
      details: [
        "User Research: Understand target users for better design decisions.",
        "Wireframes: Structural layouts to visualize app navigation.",
        "High-Fidelity Mockups: Pixel-perfect screen designs with consistent branding.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "App Prototyping",
      description: "Interactive demos before development.",
      details: [
        "Clickable Prototypes: Simulate user flow and interactions.",
        "Usability Testing: Validate app usability before coding.",
        "Client Feedback Integration: Iterate designs based on reviews.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Cross-Platform App Design",
      description: "Design once, deploy everywhere.",
      details: [
        "Consistent UI: Unified experience on iOS and Android.",
        "Platform Guidelines: Follow native design principles (Material/Apple HIG).",
        "Responsive Layouts: Optimized for all screen sizes.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "App Store Design Assets",
      description: "Design assets for better store visibility.",
      details: [
        "App Icons: Eye-catching icons that align with app theme.",
        "Screenshots: Visual storytelling to increase downloads.",
        "Store Banners: Promotional graphics and feature sections.",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Starter Design Pack",
      price: "",
      features: [
        "3-5 Screens Design",
        "Basic UI Kit",
        "Figma Source File",
        "Delivery in 4 Days",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Business Design Pack",
      price: "",
      features: [
        "Up to 10 Screens",
        "Custom UI/UX Design",
        "Prototype + Developer Handoff",
        "Delivery in 7 Days",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Premium Design Suite",
      price: "",
      features: [
        "15+ Screens + Assets",
        "Animations & Microinteractions",
        "App Icon + Store Kit",
        "Priority Support + Revisions",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: mobileapp_main_coverimage,
  title: "Need Modern Mobile App Designs?",
  subtitle:
    "Cyber Space Digital helps businesses craft beautiful, user-focused mobile app interfaces that leave a lasting impression.",
  coverImage: {
    src: mobileapp_main_coverimage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "Do you design for both iOS and Android?",
      answer:
        "Yes, we design mobile apps compatible with iOS, Android, and cross-platform frameworks like React Native and Flutter.",
    },
    {
      question: "What tools do you use for designing mobile apps?",
      answer:
        "We use industry-standard tools like Figma, Adobe XD, and Sketch for designing responsive and modern app interfaces.",
    },
    {
      question: "Can I see a prototype before development?",
      answer:
        "Yes, we offer interactive prototypes that simulate app flow and UI behavior so you can validate the design early.",
    },
    {
      question: "Are your designs developer-friendly?",
      answer:
        "Absolutely. We provide structured files, design tokens, and specs that make it easy for developers to implement.",
    },
    {
      question: "Can you help with App Store assets too?",
      answer:
        "Yes, our Premium package includes app icons, screenshots, banners, and promotional graphics optimized for the App Store and Google Play.",
    },
    {
      question: "Do you offer post-delivery revisions?",
      answer:
        "Yes. Each package includes a set number of revisions. The Premium plan includes priority support and extended revision scope.",
    },
  ],
};
export const IOSAppDevelopmentDetails = {
  SeoName: {
    seotitle: "IOSAppDevelopmentDetailsseo",
  },
  section2: {
    tagline: "Looking to launch your app on the Apple ecosystem?",
    heading: "Custom iOS App Development for Business Success",
    description:
      "Cyber Space Digital specializes in developing secure, scalable, and high-performance iOS applications. Whether it's a business app, e-commerce platform, or SaaS solution, we ensure seamless experiences across all Apple devices.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Custom iOS App Development",
      description: "Tailored apps for iPhone, iPad, and Apple Watch.",
      details: [
        "Business Apps: CRM, ERP, HRM solutions with native performance.",
        "E-commerce & Booking Apps: Feature-rich shopping and scheduling apps.",
        "Utility & Productivity Apps: Tools to streamline operations and enhance user value.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "UI/UX for iOS",
      description: "Designs built with Apple Human Interface Guidelines.",
      details: [
        "Modern UI: Clean, intuitive, and fluid interfaces.",
        "User-Centered UX: Focus on flow, performance, and accessibility.",
        "Dark Mode & Retina Ready: Optimized for the latest iOS features.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "App Store Deployment",
      description: "Smooth submission and approval process.",
      details: [
        "App Store Optimization: Metadata, keywords, and previews.",
        "Code Signing & Provisioning: Proper setup for secure distribution.",
        "Compliance & Guidelines: Ensure App Store approval on first try.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "iOS App Maintenance",
      description: "Ensure long-term app health and performance.",
      details: [
        "iOS Updates Compatibility: Stay compatible with the latest iOS versions.",
        "Crash Monitoring: Real-time logs and fixes.",
        "Feature Enhancements: Add new modules or improve UX post-launch.",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Basic iOS App",
      price: "",
      features: [
        "Up to 5 Screens",
        "Static Pages & Forms",
        "App Store Submission",
        "Delivery in 10 Days",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Business iOS App",
      price: "",
      features: [
        "Up to 10 Screens",
        "Dynamic Features (API, DB)",
        "Push Notifications",
        "1 Month Maintenance",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Advanced iOS Solution",
      price: "",
      features: [
        "Unlimited Screens & Modules",
        "Authentication & Payment Gateway",
        "Real-Time Features",
        "Priority Support + AMC",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: mobileapp_main_coverimage,
  title: "Professional iOS App Development",
  subtitle:
    "Cyber Space Digital delivers robust iOS applications that meet Apple standards and empower your business with seamless digital solutions.",
  coverImage: {
    src: mobileapp_main_coverimage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "Do you build apps for both iPhone and iPad?",
      answer:
        "Yes, our iOS apps are designed to be fully responsive and compatible with iPhone, iPad, and Apple Watch if needed.",
    },
    {
      question: "Can you publish the app on the App Store for us?",
      answer:
        "Absolutely. We handle everything from provisioning profiles to submitting the app and ensuring approval.",
    },
    {
      question: "What technologies do you use for iOS apps?",
      answer:
        "We use Swift, SwiftUI, and Xcode for native iOS development. For hybrid apps, we also offer React Native and Flutter options.",
    },
    {
      question: "Can you integrate APIs and backend systems?",
      answer:
        "Yes. We specialize in building apps that communicate with secure APIs and databases, whether custom or third-party.",
    },
    {
      question: "Do I own the app and source code?",
      answer:
        "Yes. Upon final payment, you retain full ownership of the app, source code, and all associated assets.",
    },
    {
      question: "Is post-launch support available?",
      answer:
        "Yes. All plans include limited maintenance, with AMC options available for long-term support and updates.",
    },
  ],
};
export const AndroidAppDevelopmentDetails = {
  SeoName: {
    seotitle: "AndroidAppDevelopmentDetailsseo",
  },
  section2: {
    tagline: "Target Billions of Android Users Worldwide",
    heading: "Custom Android App Development for Every Business Need",
    description:
      "At Cyber Space Digital, we design and develop secure, scalable, and intuitive Android applications that deliver real business value. From startups to enterprise-grade apps, we ensure performance, compatibility, and user satisfaction.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Native Android App Development",
      description: "Robust apps built with Kotlin and Java.",
      details: [
        "Business Apps: CRM, ERP, Inventory, HRM tailored to Android.",
        "E-commerce Apps: Online shopping, payments, and product management.",
        "Social & Utility Apps: Feature-rich applications for daily needs.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Modern UI/UX Design for Android",
      description: "User-friendly designs aligned with Material Design.",
      details: [
        "Clean Interface: Optimized layouts and visual hierarchy.",
        "Dark Mode Support: Compatible with Android's theme system.",
        "Performance Optimized: Lightweight and smooth experience.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Play Store Deployment & Optimization",
      description: "End-to-end publishing and ASO support.",
      details: [
        "Google Play Submission: We handle all compliance and testing.",
        "App Store Optimization: Improve visibility with keywords and media.",
        "Beta Testing & Feedback Integration.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Maintenance & Upgrades",
      description: "Keep your app updated and functioning smoothly.",
      details: [
        "OS Version Compatibility: Android 10+ ready.",
        "Bug Fixes & Crash Reports: Ongoing support and monitoring.",
        "Feature Expansion: Easily add modules post-launch.",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Basic Android App",
      price: "",
      features: [
        "Up to 5 Screens",
        "Static Content & Contact Form",
        "Play Store Submission",
        "Delivery in 7 Days",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Business Android App",
      price: "",
      features: [
        "Up to 10 Screens",
        "Dynamic Content + API Integration",
        "Push Notifications",
        "1 Month Free Support",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Advanced Android Solution",
      price: "",
      features: [
        "Unlimited Screens & Modules",
        "Authentication & Payment Gateway",
        "Live Chat, Real-time Sync",
        "AMC & Priority Support",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: mobileapp_main_coverimage,
  title: "Professional Android App Development",
  subtitle:
    "Cyber Space Digital helps you connect with Android users through high-quality, fast, and future-ready mobile apps.",
  coverImage: {
    src: mobileapp_main_coverimage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "Which technologies do you use for Android app development?",
      answer:
        "We primarily use Kotlin and Java for native apps, and Flutter or React Native for cross-platform solutions if needed.",
    },
    {
      question: "Do you handle publishing the app on Google Play?",
      answer:
        "Yes, we take care of the complete process including Play Store account setup, signing, testing, and submission.",
    },
    {
      question: "Can the app be integrated with my website or database?",
      answer:
        "Absolutely. We specialize in custom backend integration using REST APIs, Firebase, or direct database connections.",
    },
    {
      question: "Do I get access to the apps source code?",
      answer:
        "Yes, full source code and project files are handed over upon completion and payment.",
    },
    {
      question: "Will the app work on all Android phones?",
      answer:
        "Yes, we ensure compatibility with major Android versions (10 and above) and various screen sizes.",
    },
    {
      question: "What happens after the app is live?",
      answer:
        "We offer 1 month of free maintenance and the option to enroll in an AMC for continued support and upgrades.",
    },
  ],
};
export const CrossPlatformAppDevelopmentDetails = {
  SeoName: {
    seotitle: "CrossPlatformAppDevelopmentDetailsseo",
  },
  section2: {
    tagline: "One Codebase. Multiple Platforms.",
    heading: "Cross-Platform App Development for Android & iOS",
    description:
      "At Cyber Space Digital, we build high-performance mobile apps using modern frameworks like Flutter and React Native. Launch on both Android and iOS with reduced development time and cost”without compromising user experience.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Flutter App Development",
      description: "Googles UI toolkit for natively compiled apps.",
      details: [
        "Fast Performance: Native-like speed and animations.",
        "Custom UI: Pixel-perfect design across platforms.",
        "Hot Reload: Faster development and testing cycles.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "React Native App Development",
      description: "Build apps with JavaScript and native components.",
      details: [
        "Cross-Platform Codebase: Reuse up to 90% of the code.",
        "Community & Plugin Support: Faster feature integration.",
        "Live Updates: OTA updates without app store resubmission.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Hybrid App UI/UX Design",
      description: "Consistent UI across Android and iOS.",
      details: [
        "Unified Design: No compromise in aesthetics.",
        "Responsive Layouts: Adapts to all screen sizes.",
        "Accessibility Optimized: For all user types.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "App Store & Play Store Publishing",
      description: "Launch your app on both platforms simultaneously.",
      details: [
        "Platform Guidelines: Compliance with Google and Apple standards.",
        "ASO Optimization: Better visibility in app stores.",
        "App Testing: QA across multiple devices and OS versions.",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Basic Cross-Platform App",
      price: "",
      features: [
        "Up to 5 Screens",
        "Static Content",
        "Android + iOS Build",
        "Store Submission",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Business Cross-Platform App",
      price: "",
      features: [
        "Up to 10 Screens",
        "API & Backend Integration",
        "Push Notifications",
        "1 Month Maintenance",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Advanced Hybrid App",
      price: "",
      features: [
        "Unlimited Modules",
        "Live Chat, Login, Payment Gateway",
        "Real-time Database Integration",
        "Priority Support + AMC",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: mobileapp_main_coverimage,
  title: "Cross-Platform App Development Services",
  subtitle:
    "Launch mobile apps faster and smarter with our expert cross-platform development. One app. Every user.",
  coverImage: {
    src: mobileapp_main_coverimage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "What is cross-platform app development?",
      answer:
        "Cross-platform development allows you to create apps that work on both Android and iOS using a single codebase. It saves time, cost, and effort compared to building separate native apps.",
    },
    {
      question: "Which frameworks do you use?",
      answer:
        "We use Flutter (by Google) and React Native (by Meta) based on your apps complexity, performance needs, and future scalability.",
    },
    {
      question: "Is there any compromise on performance?",
      answer:
        "No. Apps built with Flutter and React Native are optimized for native-like performance and offer smooth user experience.",
    },
    {
      question: "Can I launch on both Play Store and App Store?",
      answer:
        "Yes. We provide publishing services and ensure your app meets all the guidelines of both platforms.",
    },
    {
      question: "Will I get the source code?",
      answer:
        "Yes, full source code and documentation will be handed over upon completion.",
    },
    {
      question: "Can I scale the app later?",
      answer:
        "Absolutely. Our architecture supports future feature expansion and scaling across devices and platforms.",
    },
  ],
};
export const AppPrototypingDetails = {
  SeoName: {
    seotitle: "AppPrototypingDetailsseo",
  },
  section2: {
    tagline: "Validate Before You Build.",
    heading: "Interactive App Prototypes That Bring Your Idea to Life",
    description:
      "At Cyber Space Digital, we help you visualize your app idea with high-fidelity prototypes. Test user flows, validate designs, and impress investors before writing a single line of code.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "UI/UX Wireframing",
      description: "Basic layout of your apps structure and flow.",
      details: [
        "User Journey Mapping: Define app goals and key actions.",
        "Low-Fidelity Wireframes: Focus on structure, not visuals.",
        "Page Navigation Flow: Ensure smooth experience from screen to screen.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Interactive App Prototypes",
      description: "Clickable, high-fidelity mockups of your app.",
      details: [
        "Realistic Design: Looks like the final app without backend.",
        "Clickable Elements: Mimic interactions, navigation, and animations.",
        "Testable Flows: Validate usability and structure with users/stakeholders.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "User Testing & Feedback",
      description: "Get insights from users before development.",
      details: [
        "Usability Testing: Discover pain points and friction.",
        "Iterative Improvements: Refine based on actual usage.",
        "Stakeholder Presentations: Showcase concept for approvals/funding.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Design-to-Development Handoff",
      description: "Smooth transition from prototype to code.",
      details: [
        "Figma/Adobe XD Handoff: Developer-friendly assets & specs.",
        "Code-ready Design: Structured with components and responsiveness.",
        "Collaboration with Dev Team: Onboarding and clarification support.",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Basic Prototype",
      price: "",
      features: [
        "3-5 App Screens",
        "Low-Fidelity Wireframes",
        "PDF or Image Export",
        "Delivery in 3 Days",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Interactive Prototype",
      price: "",
      features: [
        "5-10 Screens",
        "High-Fidelity UI",
        "Interactive Navigation",
        "Stakeholder Ready",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Full App UX Flow",
      price: "",
      features: [
        "Complete App Flow",
        "User Testing Reports",
        "Developer Handoff Assets",
        "Unlimited Revisions (for 7 days)",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: mobileapp_main_coverimage,
  title: "App Prototyping & UI Mockups",
  subtitle:
    "Before you build, prototype it. Bring your vision to life, gather feedback, and gain clarity with interactive app prototypes.",
  coverImage: {
    src: mobileapp_main_coverimage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "What is app prototyping?",
      answer:
        "App prototyping is the process of designing an interactive model of your app before development. It helps visualize user flow, design, and functionality.",
    },
    {
      question: "Do I need a prototype before development?",
      answer:
        "Yes. A prototype helps clarify requirements, save costs, get approvals, and test usability before investing in full development.",
    },
    {
      question: "Which tools do you use for prototyping?",
      answer:
        "We use Figma, Adobe XD, and InVision depending on your preferences and complexity. Youll get shareable links and downloadable formats.",
    },
    {
      question: "Can I present this prototype to investors?",
      answer:
        "Absolutely. Our high-fidelity prototypes are great for pitching your app idea to investors, partners, or stakeholders.",
    },
    {
      question: "Is feedback-based revision included?",
      answer:
        "Yes. We offer revisions based on user or team feedback during the prototype phase (based on your selected package).",
    },
    {
      question: "Will developers understand the prototype?",
      answer:
        "Yes. Our deliverables include design specs, assets, and developer-ready files for a smooth handoff.",
    },
  ],
};
export const AppTestingandQualityAssuranceDetails = {
  SeoName: {
    seotitle: "AppTestingandQualityAssuranceDetailsseo",
  },
  section2: {
    tagline: "Flawless Apps. Happy Users.",
    heading: "Comprehensive App Testing & Quality Assurance Services",
    description:
      "At Cyber Space Digital, we ensure your mobile app is bug-free, reliable, and user-friendly. Our QA specialists test across devices, OS versions, and user scenarios to deliver a seamless experience for your customers.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Manual App Testing",
      description: "Real-device testing for accuracy and usability.",
      details: [
        "UI & UX Testing: Visual accuracy and intuitive navigation.",
        "Functionality Testing: Ensure each feature works as intended.",
        "Edge Case Testing: Test rare user behaviors and flows.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Automated App Testing",
      description: "Faster testing using scripts and frameworks.",
      details: [
        "Test Automation Setup: Selenium, Appium, or Detox.",
        "Regression Testing: Validate updates without breaking existing features.",
        "Performance Monitoring: App speed, memory, and stability checks.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Cross-Device & Cross-Platform Testing",
      description: "Test your app on various devices and OS versions.",
      details: [
        "Android & iOS: Broad version compatibility testing.",
        "Screen Sizes: Phones, tablets, and foldables.",
        "Real Device & Emulator Testing: Practical and scalable testing.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Beta Testing & User Feedback",
      description: "Release your app to real users for final insights.",
      details: [
        "Beta App Distribution: Closed-group testing via TestFlight or Play Console.",
        "User Feedback Gathering: In-app surveys or feedback forms.",
        "Bug Reporting Tools: Integration with Jira, Trello, or Notion.",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Basic QA",
      price: "",
      features: [
        "Manual Testing",
        "5 Screens / Modules",
        "Bug Report (PDF)",
        "2 Revisions",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Business QA",
      price: "",
      features: [
        "Manual + Automated Testing",
        "Cross-Platform Devices",
        "Performance Testing",
        "3 Revisions + Consultation",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Advanced QA & Beta Launch",
      price: "",
      features: [
        "Full App QA (up to 20 modules)",
        "Real Device Testing",
        "Beta Launch + Feedback",
        "Post-launch Bug Fix Report",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: mobileapp_main_coverimage,
  title: "Mobile App QA & Testing Services",
  subtitle:
    "Deliver a polished and stable app to your users. Our QA experts identify and resolve bugs before your app hits the market.",
  coverImage: {
    src: mobileapp_main_coverimage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "Why is app testing important?",
      answer:
        "Testing ensures your app functions as expected, is free of bugs, and offers a smooth user experience across devices and platforms.",
    },
    {
      question: "Do you test on real devices?",
      answer:
        "Yes. We test on both emulators and a range of real devices to ensure compatibility and real-world performance.",
    },
    {
      question: "What types of testing do you perform?",
      answer:
        "We offer UI/UX testing, functionality testing, regression testing, performance testing, and cross-platform compatibility testing.",
    },
    {
      question: "Is automated testing included?",
      answer:
        "Yes, our Business and Advanced QA packages include automated test cases using tools like Appium or Selenium for repeatable scenarios.",
    },
    {
      question: "Will I get a report of all bugs and issues?",
      answer:
        "Absolutely. We provide a detailed bug report in PDF or shared dashboard format, along with screenshots or video evidence where applicable.",
    },
    {
      question: "Can you support beta testing with users?",
      answer:
        "Yes. We assist in launching your app to a controlled group via TestFlight (iOS) or Google Play Beta (Android) and collecting valuable user feedback.",
    },
  ],
};
export const AppMaintenanceandSupportDetails = {
  SeoName: {
    seotitle: "AppMaintenanceandSupportDetailsseo",
  },
  section2: {
    tagline: "Keep Your App Running Smoothly.",
    heading: "Reliable App Maintenance & Ongoing Support",
    description:
      "At Cyber Space Digital, we dont just build your app”we keep it running efficiently. From regular updates to emergency fixes, our maintenance services ensure peak performance, security, and compatibility across devices.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Regular App Updates",
      description: "Stay current with the latest OS and feature updates.",
      details: [
        "OS Compatibility Updates: Ensure smooth functioning across Android/iOS versions.",
        "Code Refactoring: Improve performance and reduce bugs.",
        "Third-Party SDK Upgrades: Stay updated with dependencies like Firebase, Stripe, etc.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Bug Fixes & Crash Recovery",
      description: "Swift response to issues and app crashes.",
      details: [
        "Crash Logs Analysis: Identify root causes of failures.",
        "Hotfix Deployment: Emergency fixes rolled out quickly.",
        "User Issue Resolution: Tackle real-world usage problems.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Performance Optimization",
      description: "Ensure your app runs fast and smooth.",
      details: [
        "Speed Optimization: Faster load and transition times.",
        "Memory Leak Fixes: Prevent app slowdowns and crashes.",
        "Analytics Monitoring: Real-time insights into app performance.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Support & Assistance",
      description: "Ongoing help whenever you need it.",
      details: [
        "Technical Support: Email, chat, or ticket-based helpdesk.",
        "Consultations: Suggest feature improvements and UX tweaks.",
        "Documentation & Training: Guide updates and onboarding support.",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Basic Maintenance",
      price: "",
      features: [
        "Minor Bug Fixes",
        "Basic Compatibility Updates",
        "Email Support",
        "2 Requests/Month",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Business Support",
      price: "",
      features: [
        "Regular OS/SDK Updates",
        "Performance Monitoring",
        "Priority Bug Fixes",
        "Up to 5 Support Requests",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Premium Care Plan",
      price: "",
      features: [
        "Unlimited Support Tickets",
        "24x7 Emergency Fixes",
        "Monthly Feature Reviews",
        "Analytics Reports",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: mobileapp_main_coverimage,
  title: "Mobile App Maintenance & Support Services",
  subtitle:
    "Ensure your mobile app stays secure, functional, and fast with our proactive maintenance and support plans.",
  coverImage: {
    src: mobileapp_main_coverimage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "Why do I need app maintenance after launch?",
      answer:
        "Mobile platforms evolve constantly. Regular maintenance ensures your app remains compatible, secure, and bug-free as user behavior and technologies change.",
    },
    {
      question: "What happens if my app crashes unexpectedly?",
      answer:
        "We offer emergency bug fixes and crash recovery services as part of our Business and Premium plans to resolve such issues quickly.",
    },
    {
      question: "How do you handle OS updates like iOS or Android versions?",
      answer:
        "We test your app on new OS versions and update code or dependencies to maintain performance and compatibility.",
    },
    {
      question: "Whats included in a monthly support plan?",
      answer:
        "Depending on the plan, youll get bug fixes, performance optimization, OS updates, support requests, analytics, and technical consultation.",
    },
    {
      question: "Can I switch or cancel my maintenance plan?",
      answer:
        "Yes, our plans are flexible. You can upgrade, downgrade, or cancel with a 15-day notice.",
    },
    {
      question: "Do you offer AMC (Annual Maintenance Contract)?",
      answer:
        "Yes, we offer discounted AMC plans for long-term clients covering all maintenance needs for a year.",
    },
  ],
};
export const AppSecurityDetails = {
  SeoName: {
    seotitle: "AppSecurityDetailsseo",
  },
  section2: {
    tagline: "Secure Your App. Protect Your Users.",
    heading: "Mobile App Security & Data Protection Services",
    description:
      "Cyber Space Digital ensures your mobile apps are safe from vulnerabilities, data breaches, and malicious threats. We implement robust security measures to protect both your business and your users.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "App Vulnerability Assessment",
      description:
        "Identify and patch potential threats before theyre exploited.",
      details: [
        "Code Review: Analyze source code for logic flaws and security loopholes.",
        "Security Scanning: Use tools to scan for known vulnerabilities.",
        "Penetration Testing: Ethical hacking to simulate attacks.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "User Data Protection",
      description: "Safeguard personal and financial information.",
      details: [
        "Encryption: End-to-end data encryption for sensitive information.",
        "Authentication: Secure user login with OTP, biometrics, or OAuth.",
        "Data Storage: Secure cloud storage practices and encrypted databases.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "App Store Compliance",
      description: "Meet Google Play and Apple App Store security standards.",
      details: [
        "Secure APIs: HTTPS, token-based access, and CORS policies.",
        "Permissions Audit: Ensure minimal and justified user permissions.",
        "App Transport Security: ATS compliance for iOS.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Ongoing Monitoring & Alerts",
      description: "Stay alert with real-time threat monitoring.",
      details: [
        "Threat Detection: Detect unauthorized access or attacks.",
        "Crash & Log Monitoring: Track abnormal behavior and errors.",
        "Automated Alerts: Instant alerts for suspicious activity.",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Basic Security",
      price: "",
      features: [
        "Code Vulnerability Check",
        "Encryption Setup",
        "Login Protection",
        "Basic Report",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Advanced Security",
      price: "",
      features: [
        "Penetration Testing",
        "Secure API Integration",
        "User Data Protection",
        "Detailed Security Report",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Enterprise Security Plan",
      price: "",
      features: [
        "Ongoing Security Monitoring",
        "Compliance & Legal Guidance",
        "Threat Alerts & Remediation",
        "Monthly Audit Reports",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: mobileapp_main_coverimage,
  title: "App Security & Protection Services",
  subtitle:
    "Protect your mobile apps and user data with advanced security protocols, ethical testing, and continuous monitoring from Cyber Space Digital.",
  coverImage: {
    src: mobileapp_main_coverimage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "Why is mobile app security important?",
      answer:
        "Without proper security, your app and its users are vulnerable to data breaches, financial loss, and reputational damage. We ensure your app meets the highest security standards.",
    },
    {
      question: "Do you conduct penetration testing?",
      answer:
        "Yes. We simulate real-world attacks to detect and fix vulnerabilities before hackers can exploit them.",
    },
    {
      question: "Is data encryption included?",
      answer:
        "Yes. We implement strong encryption for user data, whether in transit or at rest.",
    },
    {
      question: "Can you help with app store compliance?",
      answer:
        "Absolutely. We ensure your app complies with both Google Play and Apple App Store security requirements.",
    },
    {
      question: "Do you provide post-launch monitoring?",
      answer:
        "Yes. Our Enterprise plan includes ongoing monitoring, alert systems, and regular audits to maintain long-term security.",
    },
    {
      question: "What security reports will I receive?",
      answer:
        "Youll receive detailed documentation of identified vulnerabilities, fixes applied, encryption standards used, and recommendations for future improvements.",
    },
  ],
};
export const AppMonetizationStrategyDetails = {
  SeoName: {
    seotitle: "AppMonetizationStrategyDetailsseo",
  },
  section2: {
    tagline: "Turn Your App Into a Revenue Stream",
    heading: "Mobile App Monetization Strategy & Implementation",
    description:
      "Cyber Space Digital helps you convert users into revenue through strategic monetization models. Whether you're launching a startup app or scaling a product, we guide you through the best ways to generate consistent income.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "In-App Advertising",
      description: "Generate income through ads without charging users.",
      details: [
        "Banner & Interstitial Ads: Integrated via Google AdMob or Facebook Audience Network.",
        "Rewarded Videos: Users watch ads in exchange for rewards.",
        "Native Ads: Seamlessly blended into your apps content.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Subscription & SaaS Models",
      description: "Create recurring revenue through subscriptions.",
      details: [
        "Freemium Model: Free basic features + paid premium upgrades.",
        "Monthly/Yearly Plans: Auto-renewal via Stripe, Razorpay, or Apple/Google billing.",
        "Trial Periods: Encourage conversions with free limited-time access.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "In-App Purchases (IAP)",
      description: "Sell digital products or features directly in the app.",
      details: [
        "One-Time Purchases: Unlock a feature or level permanently.",
        "Consumables: Credits, coins, tokens, etc.",
        "Dynamic Pricing: Based on region, behavior, or frequency.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "E-commerce Integration",
      description: "Sell physical or digital goods from within your app.",
      details: [
        "Shopping Cart & Checkout: Seamless buying process.",
        "Payment Gateways: UPI, cards, net banking, wallets.",
        "Order Tracking & Notifications: Integrated post-sale experience.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Affiliate & Referral Programs",
      description: "Encourage users to promote your app and earn.",
      details: [
        "Referral Links: Reward users for inviting others.",
        "Affiliate Marketing: Promote partner products inside your app.",
        "Commission Models: Earn from external conversions.",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Starter Strategy",
      price: "",
      features: [
        "Monetization Model Consultation",
        "Basic In-App Ads Setup",
        "Analytics Dashboard Integration",
        "Strategy Report",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Pro Monetization",
      price: "",
      features: [
        "Custom Pricing Plans",
        "Subscription or IAP Integration",
        "Ad Optimization & Testing",
        "User Behavior Analysis",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Monetization Master Suite",
      price: "",
      features: [
        "Multi-model Strategy Setup",
        "Revenue Funnel Design",
        "Advanced Analytics & Reporting",
        "Ongoing Optimization & Support",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: mobileapp_main_coverimage,
  title: "App Monetization Services",
  subtitle:
    "Cyber Space Digital helps you monetize mobile apps through ads, subscriptions, purchases, and more ” all tailored to your goals.",
  coverImage: {
    src: mobileapp_main_coverimage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "What is the best monetization model for my app?",
      answer:
        "It depends on your app type, audience, and goals. We help analyze and suggest the most profitable model ” ads, subscriptions, purchases, or a combination.",
    },
    {
      question: "Can I combine multiple monetization methods?",
      answer:
        "Yes. Many apps use a hybrid approach ” e.g., freemium + ads + IAP. We ensure its not intrusive and delivers value to users.",
    },
    {
      question: "Are subscriptions supported in both iOS and Android?",
      answer:
        "Yes, we implement auto-renewing subscriptions using Play Store and App Store APIs, including trials, upgrades, and cancellations.",
    },
    {
      question: "Can you help me set up in-app purchases?",
      answer:
        "Absolutely. We configure and test IAPs for both platforms, including consumable, non-consumable, and subscription-based items.",
    },
    {
      question: "What are affiliate and referral programs?",
      answer:
        "Affiliate programs let you earn by promoting partner products; referral programs reward users for inviting others ” boosting growth and revenue.",
    },
    {
      question: "How do I track app revenue?",
      answer:
        "We integrate analytics tools like Firebase, RevenueCat, or custom dashboards so you can track sales, usage, churn, and ROI.",
    },
  ],
};
export const AppStoreOptimizationDetails = {
  SeoName: {
    seotitle: "AppStoreOptimizationDetailsseo",
  },
  section2: {
    tagline: "Maximize Your App's Visibility",
    heading: "App Store Optimization (ASO) Services",
    description:
      "Cyber Space Digital helps you boost app downloads and visibility with proven App Store Optimization strategies. From keyword research to compelling visuals, we optimize your app to rank higher and convert better.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Keyword Research & Strategy",
      description: "Target high-traffic and relevant keywords for your app.",
      details: [
        "Competitor Analysis: Discover what keywords competitors rank for.",
        "Keyword Placement: Strategic use in title, subtitle, and metadata.",
        "Localization: Region-wise keyword optimization.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "App Title & Description Optimization",
      description: "Craft compelling content to rank and convert.",
      details: [
        "SEO-Optimized Titles: Balanced keyword and brand positioning.",
        "Persuasive Descriptions: Highlight features, benefits, and CTAs.",
        "Formatting for Readability: Bullet points, emojis, and spacing.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Visual Asset Enhancement",
      description: "Design store graphics that attract and engage.",
      details: [
        "App Icons: Professional, branded, and scalable design.",
        "Screenshots & Videos: Showcase app experience and features.",
        "A/B Testing: Optimize visuals for higher conversion.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "App Reviews & Ratings Strategy",
      description: "Improve your credibility with organic reviews.",
      details: [
        "Review Generation: Ethical ways to encourage user feedback.",
        "Sentiment Analysis: Monitor and respond to feedback.",
        "Ratings Boosting: Improve user experience to raise scores.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "App Localization & Global Reach",
      description: "Expand reach by adapting to multiple languages.",
      details: [
        "Language Translation: Localize metadata and descriptions.",
        "Cultural Relevance: Adjust images and messages per region.",
        "Geo-targeted Keyword Optimization.",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Basic ASO",
      price: "",
      features: [
        "Keyword Strategy",
        "Optimized Title & Description",
        "Basic Visual Suggestions",
        "ASO Report",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Pro ASO Package",
      price: "",
      features: [
        "Full Metadata Optimization",
        "Custom Icons & Screenshots",
        "Review Generation Strategy",
        "A/B Testing Setup",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Global ASO Suite",
      price: "",
      features: [
        "Multi-language Localization",
        "Advanced Visual Asset Creation",
        "Store Analytics & Reporting",
        "Ongoing Optimization (30 Days)",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: mobileapp_main_coverimage,
  title: "App Store Optimization Services",
  subtitle:
    "Cyber Space Digital helps your app climb the charts with expert ASO techniques ” more visibility, better conversion, and increased installs.",
  coverImage: {
    src: mobileapp_main_coverimage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "What is App Store Optimization (ASO)?",
      answer:
        "ASO is the process of improving your apps visibility and conversion rate in app stores. Its like SEO for mobile apps.",
    },
    {
      question: "How long does it take to see ASO results?",
      answer:
        "You may start seeing improvements in visibility within 1“2 weeks. Full download impact usually appears within 30“45 days.",
    },
    {
      question: "Do you support both Android and iOS?",
      answer:
        "Yes. We optimize apps for both Google Play Store and Apple App Store, following their specific guidelines.",
    },
    {
      question: "Can you help with app reviews and ratings?",
      answer:
        "Yes. We use ethical methods to improve your apps ratings and encourage more genuine reviews from your users.",
    },
    {
      question: "Is ASO a one-time service?",
      answer:
        "While we offer one-time ASO packages, ongoing optimization delivers the best long-term results as trends and competition change.",
    },
    {
      question: "Will ASO improve my app downloads?",
      answer:
        "Yes. A well-optimized app sees increased visibility, which leads to more impressions and higher download rates.",
    },
  ],
};
export const EcommerceAppDevelopmentDetails = {
  SeoName: {
    seotitle: "EcommerceAppDevelopmentDetailsseo",
  },
  section2: {
    tagline: "Launch Your Own Shopping App",
    heading: "Custom E-commerce App Development Solutions",
    description:
      "Cyber Space Digital builds scalable, secure, and feature-rich e-commerce mobile apps tailored to your business model. From product management to secure payments, we deliver everything you need to run your online store efficiently.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Custom E-Commerce App Development",
      description: "Tailored apps for your business model and products.",
      details: [
        "Custom UI/UX: Designed to match your brand and audience.",
        "Multiple Product Types: Physical, digital, or service-based.",
        "Vendor or Single Store Options.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Product Catalog & Inventory Management",
      description: "Manage your product listings and stock easily.",
      details: [
        "Categories & Filters: Help users find products faster.",
        "Stock Alerts: Get notified about low inventory.",
        "Bulk Upload: Easily manage large catalogs.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Secure Payment Gateway Integration",
      description: "Accept payments from multiple sources.",
      details: [
        "UPI, Cards, Wallets, Net Banking Support.",
        "Cash on Delivery Options.",
        "PCI-DSS Compliant Payment Flow.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "User Profile & Order Management",
      description: "Track users, orders, and delivery.",
      details: [
        "Customer Login, Address Book, Wishlist.",
        "Order Tracking & Notifications.",
        "Returns, Cancellations, and Support Ticketing.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Admin Dashboard & Analytics",
      description: "Manage everything from a single panel.",
      details: [
        "Product, Orders, Users, and Coupon Control.",
        "Revenue & Sales Reports.",
        "Customer Behavior Insights.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Marketing & Loyalty Features",
      description: "Tools to boost retention and revenue.",
      details: [
        "Discount Coupons & Flash Sales.",
        "Push Notifications & Abandoned Cart Recovery.",
        "Loyalty Points & Referral Programs.",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Starter E-Commerce App",
      price: "",
      features: [
        "Single Vendor App",
        "Basic Product Catalog",
        "Cash on Delivery + UPI",
        "Delivery in 10 Days",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Growth Plan",
      price: "",
      features: [
        "Custom UI/UX",
        "Inventory + Coupon System",
        "Push Notifications",
        "Admin Dashboard",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Premium Store Suite",
      price: "",
      features: [
        "Multi-Vendor Support",
        "Advanced Reports & Analytics",
        "Marketing Tools + Loyalty Program",
        "iOS + Android Delivery",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: mobileapp_main_coverimage,
  title: "E-Commerce App Development Services",
  subtitle:
    "Cyber Space Digital empowers your business with high-performance mobile apps for online selling ” fast, scalable, and built to grow.",
  coverImage: {
    src: mobileapp_main_coverimage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "What platforms do you support for e-commerce apps?",
      answer:
        "We develop e-commerce apps for Android, iOS, and cross-platform frameworks like React Native and Flutter.",
    },
    {
      question: "Can I manage my store from an admin panel?",
      answer:
        "Yes. Youll get a user-friendly admin dashboard to manage products, orders, users, and reports in real-time.",
    },
    {
      question: "Do you offer multi-vendor marketplace features?",
      answer:
        "Absolutely. We can build multi-seller apps like Amazon or Flipkart where each vendor has their own panel.",
    },
    {
      question: "Will my app support payments and order tracking?",
      answer:
        "Yes. All plans include payment gateway integration and real-time order tracking features for users.",
    },
    {
      question: "Can you customize the app for my business?",
      answer:
        "Of course! Every element including UI, features, and workflows can be tailored to your exact business model.",
    },
    {
      question: "Do you provide app store publishing support?",
      answer:
        "Yes. We assist with Google Play and Apple App Store submission, compliance, and listing optimization.",
    },
  ],
};

//digitalmarketing
